var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Italic = function Italic(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 30 30' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M19 11V9h-7v2h2.7l-1.6 10H11v2h7v-2h-2.9l1.6-10z' })
    )
  );
};
/*eslint-enable */

export default Italic;
//# sourceMappingURL=Italic.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Italic.js